<template>
  <vx-card title="Footfall Details">
    <div id="data-list-list-view" class="data-list-container">
      <vs-table ref="table">
        <template>
          <tbody>
          <vs-tr>
            <vs-th sort-key="name">Name</vs-th>
            <vs-td>
              <p class="product-name font-medium truncate">{{footFall.name}}</p>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th sort-key="name">Gender</vs-th>
            <vs-td>
              <p class="product-name font-medium truncate">{{footFall.gender}}</p>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th sort-key="name">Email</vs-th>
            <vs-td>
              <p class="product-name font-medium truncate">{{footFall.email}}</p>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th sort-key="name">Mobile</vs-th>
            <vs-td>
              <p class="product-name font-medium truncate">{{footFall.mobile}}</p>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th sort-key="name">Sources</vs-th>
            <vs-td>
              <p class="product-name font-medium truncate">{{footFall.sources}}</p>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th sort-key="name">Reason</vs-th>
            <vs-td>
              <p class="product-name font-medium truncate">{{footFall.reason}}</p>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th sort-key="name">Product</vs-th>
            <vs-td>
              <p class="product-name font-medium truncate">{{footFall.product}}</p>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th sort-key="name">Brand</vs-th>
            <vs-td>
              <p class="product-name font-medium truncate">{{footFall.brand}}</p>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th sort-key="name">Follow Up date</vs-th>
            <vs-td>
              <p class="product-name font-medium truncate">{{footFall.reminder_date}}</p>
            </vs-td>
          </vs-tr>

          </tbody>
        </template>
      </vs-table>
    </div>
  </vx-card>
</template>
<script>
  import gql from 'graphql-tag'

  export default {
    data () {
      return {
        footFall: ''
      }
    },
    apollo: {
      footfall: {
        query: gql`
         query footfall($id: ID){
          footfall(id:$id){
            id
            name
            gender
            email
            mobile
            sources
            suffix
            reason
            product
            brand
            reminder_date
            created_at
            updated_at
          }
         }
         `,
        variables () {
          return {
            id: this.$route.params.id
          }
        },
        update: (data) => data.footfall
      }

    },
    watch: {
      footfall (value) {
      if(value !== null){
        this.footFall = value;
        console.log("Footfall = ", this.footFall);
      }
      }
    },
    computed: {
      validateForm () {
        return !this.errors.any() && this.appNid === true && this.appMob === true && this.appOccu === true && this.gNid === true && this.gMob === true && this.gOcc === true
      }
    },
    methods: {
      getOrderStatusColor (status) {
        if (status === 'on_hold') return 'warning'
        if (status === 'delivered') return 'success'
        if (status === 'canceled') return 'danger'
        return 'primary'
      },
      getPopularityColor (num) {
        if (num > 90) return 'success'
        if (num > 70) return 'primary'
        if (num >= 50) return 'warning'
        if (num < 50) return 'danger'
        return 'primary'
      },
      guarantorPreviewById (id) {
        this.$router.push('/guarantorDetails/' + id).catch(() => {
        })
      }
    }
  }

</script>
<style>
  .vx-col table tr > td {
    vertical-align: top;
    min-width: 250px;
    word-break: break-all;
  }

  #page-user-view table td {
    vertical-align: top;
    min-width: 250px;
    word-break: break-all;
  }

  .nav-img-for-gu img {
    height: 55px;
    padding: 5px 0;
  }

  #user-data {
    padding: 15px 30px;
  }
  sup {
    font-size: 16px;
    color: red;
  }
</style>
